import { Box, Button, Typography } from '@mui/material';
import { formatMediaUrl } from '../utils';
import { File } from '@peerless/data-access/strapi';
import { RouterLink } from '@/navigation';

interface QuickLinkProps {
  image?: File;
  title: string;
  url: string;
}
export const QuickLink = ({ title, image, url }: QuickLinkProps) => (
  <Button
    href={url}
    variant={'outlined'}
    color={'secondary'}
    component={RouterLink}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      padding: '1rem',
      color: 'common.white',
      borderColor: 'common.white',
      borderRadius: '1rem',
      backgroundColor: '#53535A',
      '&:hover': {
        backgroundColor: 'common.white',
        borderColor: 'primary.main',
        color: 'primary.main',
      },
    }}
  >
    {image && (
      <Box
        component={'img'}
        src={formatMediaUrl(image)}
        sx={{ width: { xs: '50%', lg: '70%', xl: '100%' }, marginBottom: 1 }}
      />
    )}
    <Typography
      align={'center'}
      component={'span'}
      fontWeight={'700'}
      sx={{ flex: '1', fontSize: '1.5rem' }}
    >
      {title}
    </Typography>
  </Button>
);
